import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";
import ConsultPopup from "./ConsultPopup";
import { trackView } from "@/lib/api";

export default function SiteLayout() {
  const location = useLocation();
  const { pathname, hash, key } = location;
  useEffect(() => {
    trackView(pathname);
  }, [pathname]);
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, key]);

  return (
    <div className="bg-[#0B0F12] text-slate-100 min-h-screen overflow-x-hidden [overflow-x:clip]">
      <Navbar />
      <main><Outlet /></main>
      <Footer />
      <FloatingWhatsApp />
      <ConsultPopup />
    </div>
  );
}
